import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject, model, viewChild } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { TmsFormlyService } from 'tms-web-shared';
import {
  BaseComponent,
  BaseEditFormModalComponent,
  FormService,
  GridModalComponent,
  GridService,
  NotificationService,
} from '../../../../tms-shared';
import { UserPrinter, UserPrinterDocument } from '../../models';
import { UserPrinterDocumentService } from '../../services';

@Component({
  selector: 'app-user-printers-edit-modal',
  templateUrl: './user-printers-edit-modal.component.html',
  styleUrl: './user-printers-edit-modal.component.scss',
  imports: [GridModalComponent, AsyncPipe],
})
export class UserPrintersEditModalComponent extends BaseComponent implements OnInit {
  private readonly userPrinterDocumentService = inject(UserPrinterDocumentService);
  private readonly gridService = inject(GridService);
  private readonly formService = inject(FormService);
  private readonly formlyService = inject(TmsFormlyService);
  private readonly notificationService = inject(NotificationService);

  private readonly form = viewChild(BaseEditFormModalComponent);
  private readonly grid = viewChild(GridModalComponent);

  public readonly id = model<string>();
  public readonly model = model<UserPrinter>();
  public readonly userId = model<string>();

  protected columnDefs: ColDef[] = [
    ...this.gridService.checkboxRowSelect('documentKey', $localize`DocumentKey`),
    this.gridService.text('documentDescription', $localize`Description`),
  ];

  protected fields: FormlyFieldConfig[];

  protected rowData$: Observable<UserPrinterDocument[]>;

  ngOnInit() {
    this.getModel();
    this.getFields();
  }

  private getFields() {
    this.fields = [
      this.formlyService.text('printerName', $localize`Printer`),
      this.formlyService.text('printerAddress', $localize`Address`),
      this.formlyService.text('printMethod', $localize`Print Method`),
    ];
  }

  save() {
    this.formService.beginSave();
    this.userPrinterDocumentService
      .updateUserPrinterDocuments(
        this.id(),
        this.grid()
          .grid()
          .selectedRows.map((x: UserPrinterDocument) => x.documentId),
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.notificationService.saveSuccess($localize`User Printer Documents`);
          this.getModel();
          this.formService.endSave(false);
        },
        error: () => {
          this.notificationService.saveFail($localize`User Printer Documents`);
          this.formService.endSave(true);
        },
      });
  }

  private getModel() {
    this.rowData$ = this.userPrinterDocumentService.getAllDocuments(this.id());
    this.grid()?.grid()?.resetEdited();
  }
}
